import { Box, Container } from '@mui/material';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';

type Props = {
  children: React.ReactNode;
};
export const PageLayout = ({ children }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header />
      <Container sx={{ flex: 1, py: { xs: 2, sm: 4, md: 6 } }}>{children}</Container>
      <Footer />
    </Box>
  );
};
